<template>
  <div class="mb-24 text-center md:mb-32">
    <h2 class="heading-2 mb-12">
      {{ i18n(translations.title) }}
    </h2>
    <IconArrowDown class="inline-block" />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconArrowDown } from '@ds/icons/IconArrowDown'

import translations from './Introduction.translations'

const i18n = useI18n()
</script>
